export default __webpack_public_path__ + "static/gallery-award-gold-0fdadd922cc7d5b825244bdfbdf5335f.jpg";